/* ==========================================================================
   OBASIC — scripts do tema

   1. Preço no Pix calculado a partir do preço de cada card
   2. Carrossel de vídeos: autoplay mudo no feed, tela cheia com som ao clicar
   ========================================================================== */

(function () {
  'use strict';

  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ========================================================================
     1. PREÇO NO PIX

     O campo de texto do bloco é estático: escreve a mesma frase em todos os
     produtos. Aqui a gente lê o preço renderizado de cada card e reescreve a
     linha com o valor já descontado. Se o JS não rodar, a frase configurada
     no editor continua aparecendo.
     ======================================================================== */

  var PIX_RATE = 0.05;

  var PRICE_SELECTOR =
    'div[class*="ai-premium-collection__price-"]:not([class*="price-wrapper"])';
  var EXTRA_SELECTOR = 'div[class*="ai-premium-collection__extra-text-"]';

  function parseBRL(text) {
    var cleaned = String(text).replace(/[^\d.,]/g, '');
    if (!cleaned) return NaN;
    cleaned = cleaned.replace(/\./g, '').replace(',', '.');
    return parseFloat(cleaned);
  }

  function formatBRL(value) {
    try {
      return value.toLocaleString('pt-BR', {
        style: 'currency',
        currency: 'BRL'
      });
    } catch (e) {
      return 'R$ ' + value.toFixed(2).replace('.', ',');
    }
  }

  function applyPix(root) {
    var cards = (root || document).querySelectorAll('div[data-product-id]');

    Array.prototype.forEach.call(cards, function (card) {
      var priceEl = card.querySelector(PRICE_SELECTOR);
      var extraEl = card.querySelector(EXTRA_SELECTOR);
      if (!priceEl || !extraEl) return;

      var price = parseBRL(priceEl.textContent);
      if (!isFinite(price) || price <= 0) return;

      extraEl.textContent = formatBRL(price * (1 - PIX_RATE)) + ' no Pix';
    });
  }

  /* ========================================================================
     2. CARROSSEL DE VÍDEOS

     O autoplay mudo já vem do atributo no HTML. O JS existe para três coisas:
     garantir o play caso o navegador ignore o atributo, pausar o que sai da
     tela (economia de banda e bateria) e abrir a tela cheia com som.
     ======================================================================== */

  var modal = null;
  var modalStage = null;
  var pausedByModal = [];

  function tryPlay(video) {
    if (!video || modalIsOpen()) return;
    video.muted = true;
    var attempt = video.play();
    if (attempt && typeof attempt.catch === 'function') {
      attempt.catch(function () {
        /* Alguns navegadores só liberam autoplay após a primeira interação.
           O listener global abaixo cobre esse caso. */
      });
    }
  }

  function modalIsOpen() {
    return !!(modal && modal.open);
  }

  function playAll() {
    document.querySelectorAll('video.obvc__media').forEach(tryPlay);
  }

  function buildModal() {
    if (modal) return modal;

    modal = document.createElement('dialog');
    modal.id = 'obvc-modal';
    modal.className = 'obvc-modal';

    var close = document.createElement('button');
    close.type = 'button';
    close.className = 'obvc-modal__close';
    close.setAttribute('aria-label', 'Fechar vídeo');
    close.innerHTML =
      '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><path d="M18 6L6 18M6 6l12 12"/></svg>';
    close.addEventListener('click', function () {
      modal.close();
    });

    modalStage = document.createElement('div');
    modalStage.className = 'obvc-modal__stage';

    modal.appendChild(close);
    modal.appendChild(modalStage);
    document.body.appendChild(modal);

    /* Clicar no fundo escuro fecha */
    modal.addEventListener('click', function (event) {
      if (event.target === modal) modal.close();
    });

    /* Ao fechar: descarta o vídeo e devolve o feed ao estado anterior */
    modal.addEventListener('close', function () {
      modalStage.innerHTML = '';
      pausedByModal.forEach(tryPlay);
      pausedByModal = [];
    });

    return modal;
  }

  function openVideo(sourceVideo, label) {
    buildModal();

    /* Pausa o feed para não competir com o áudio */
    pausedByModal = [];
    document.querySelectorAll('video.obvc__media').forEach(function (video) {
      if (!video.paused) {
        video.pause();
        pausedByModal.push(video);
      }
    });

    var full = document.createElement('video');
    full.className = 'obvc-modal__video';
    full.controls = true;
    full.autoplay = true;
    full.playsInline = true;
    full.muted = false;
    full.setAttribute('aria-label', label || 'Vídeo');

    Array.prototype.forEach.call(sourceVideo.querySelectorAll('source'), function (src) {
      var clone = document.createElement('source');
      clone.src = src.src;
      clone.type = src.type;
      full.appendChild(clone);
    });

    if (sourceVideo.poster) full.poster = sourceVideo.poster;

    modalStage.appendChild(full);

    if (typeof modal.showModal === 'function') {
      modal.showModal();
    } else {
      modal.setAttribute('open', '');
    }

    full.currentTime = 0;
    full.play().catch(function () {
      /* Se o navegador recusar o áudio automático, os controles ficam ali
         para a pessoa dar play manualmente. */
    });
  }

  function initVideoCarousels(root) {
    var scope = root || document;
    var cards = scope.querySelectorAll('.obvc__card[data-obvc-open]');
    if (!cards.length) return;

    Array.prototype.forEach.call(cards, function (card) {
      if (card.dataset.obvcReady === '1') return;
      card.dataset.obvcReady = '1';

      card.addEventListener('click', function () {
        var video = card.querySelector('video.obvc__media');
        if (!video) return;
        var labelEl = card.querySelector('.obvc__label');
        openVideo(video, labelEl ? labelEl.textContent : '');
      });
    });

    var videos = scope.querySelectorAll('video.obvc__media');

    /* Toca de imediato, sem esperar a rolagem chegar na seção */
    if (!reduceMotion) {
      Array.prototype.forEach.call(videos, tryPlay);
    }

    if (reduceMotion || !('IntersectionObserver' in window)) return;

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (modalIsOpen()) return;
          if (entry.isIntersecting) {
            tryPlay(entry.target);
          } else {
            entry.target.pause();
          }
        });
      },
      { threshold: 0.2 }
    );

    Array.prototype.forEach.call(videos, function (video) {
      if (video.dataset.obvcWatched === '1') return;
      video.dataset.obvcWatched = '1';
      video.muted = true;
      observer.observe(video);
    });
  }

  /* Se o navegador barrar o autoplay, o primeiro toque na página destrava */
  ['pointerdown', 'touchstart', 'keydown'].forEach(function (evt) {
    document.addEventListener(evt, function once() {
      if (!reduceMotion) playAll();
      ['pointerdown', 'touchstart', 'keydown'].forEach(function (e2) {
        document.removeEventListener(e2, once);
      });
    });
  });

  /* ======================================================================== */

  function boot(root) {
    applyPix(root);
    initVideoCarousels(root);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      boot();
    });
  } else {
    boot();
  }

  /* O editor de tema recarrega seções sem recarregar a página */
  document.addEventListener('shopify:section:load', function (event) {
    boot(event.target);
  });
})();
